export default "__VITE_ASSET__D1kKX_mR__"